export default {
  // 生产记录
  insertScProRecord: '/ygsjzs/scProRecord/insertScProRecord',
  deleteScProRecord: '/ygsjzs/scProRecord/deleteScProRecord',
  selectScProRecordByRecordId: '/ygsjzs/scProRecord/selectScProRecordByRecordId',
  selectScProRecordByPage: '/ygsjzs/scProRecord/selectScProRecordByPage',
  exportProductionRecord: '/ygsjzs/scProductionExport/exportProductionRecord',
  // 下载包含当班日期的生产记录导入模板。
  downloadProductionRecordTemplate: '/ygsjzs/scProductionExport/downloadProductionRecordTemplate',
  // 导入
  importScProRecord: '/ygsjzs/scProRecord/importScProRecord',
  // 产品管理
  insertScProduct: '/ygsjzs/scProduct/insertScProduct',
  updateScProduct: '/ygsjzs/scProduct/updateScProduct',
  deleteScProduct: '/ygsjzs/scProduct/deleteScProduct',
  selectScProductByProductId: '/ygsjzs/scProduct/selectScProductByProductId',
  selectScProductByPage: '/ygsjzs/scProduct/selectScProductByPage',
  // 仓库管理
  insertLyWarehouse: '/ygsjzs/lyWarehouse/insertLyWarehouse',
  updateLyWarehouse: '/ygsjzs/lyWarehouse/updateLyWarehouse',
  deleteLyWarehouse: '/ygsjzs/lyWarehouse/deleteLyWarehouse',
  selectLyWarehouseByWarehouseId: '/ygsjzs/lyWarehouse/selectLyWarehouseByWarehouseId',
  selectLyWarehouseByPage: '/ygsjzs/lyWarehouse/selectLyWarehouseByPage',
  // 产品库存
  selectLyWareManById: '/ygsjzs/lyWareMan/selectLyWareManById',
  selectLyWareManByPage: '/ygsjzs/lyWareMan/selectLyWareManByPage',
  selectLyWarehouseByNum: '/ygsjzs/lyWareMan/selectLyWarehouseByNum',
  // 进出库记录
  deleteDataLyWareRec: '/ygsjzs/lyWareRec/deleteDataLyWareRec',
  selectLyWareRecById: '/ygsjzs/lyWareRec/selectLyWareRecById',
  selectLyWareRecByPage: '/ygsjzs/lyWareRec/selectLyWareRecByPage',
  // 导出进出库
  selectLyWareRecByPdf: '/ygsjzs/lyWareRec/selectLyWareRecByPdf',
  // 成品入库记录
  insertScFinishedGoodsInbound: '/ygsjzs/scFinishedGoodsInbound/insertScFinishedGoodsInbound',
  updateScFinishedGoodsInbound: '/ygsjzs/scFinishedGoodsInbound/updateScFinishedGoodsInbound',
  deleteScFinishedGoodsInbound: '/ygsjzs/scFinishedGoodsInbound/deleteScFinishedGoodsInbound',
  selectScFinishedGoodsInboundById: '/ygsjzs/scFinishedGoodsInbound/selectScFinishedGoodsInboundById',
  selectScFinishedGoodsInboundByPage: '/ygsjzs/scFinishedGoodsInbound/selectScFinishedGoodsInboundByPage',
  exportFinishedGoodsInbound: '/ygsjzs/scProductionExport/exportFinishedGoodsInbound',
  // 成品出库记录
  insertScFinishedGoodsOutbound: '/ygsjzs/scFinishedGoodsOutbound/insertScFinishedGoodsOutbound',
  updateScFinishedGoodsOutbound: '/ygsjzs/scFinishedGoodsOutbound/updateScFinishedGoodsOutbound',
  deleteScFinishedGoodsOutbound: '/ygsjzs/scFinishedGoodsOutbound/deleteScFinishedGoodsOutbound',
  selectScFinishedGoodsOutboundById: '/ygsjzs/scFinishedGoodsOutbound/selectScFinishedGoodsOutboundById',
  selectScFinishedGoodsOutboundByPage: '/ygsjzs/scFinishedGoodsOutbound/selectScFinishedGoodsOutboundByPage',
  exportFinishedGoodsOutbound: '/ygsjzs/scProductionExport/exportFinishedGoodsOutbound',
  // 投料记录
  insertScFeedingRecord: '/ygsjzs/scFeedingRecord/insertScFeedingRecord',
  updateScFeedingRecord: '/ygsjzs/scFeedingRecord/updateScFeedingRecord',
  deleteScFeedingRecord: '/ygsjzs/scFeedingRecord/deleteScFeedingRecord',
  selectScFeedingRecordById: '/ygsjzs/scFeedingRecord/selectScFeedingRecordById',
  selectScFeedingRecordByPage: '/ygsjzs/scFeedingRecord/selectScFeedingRecordByPage',
  exportFeedingRecord: '/ygsjzs/scProductionExport/exportFeedingRecord',
  // 原辅料出库记录
  insertScMaterialOutbound: '/ygsjzs/scMaterialOutbound/insertScMaterialOutbound',
  updateScMaterialOutbound: '/ygsjzs/scMaterialOutbound/updateScMaterialOutbound',
  deleteScMaterialOutbound: '/ygsjzs/scMaterialOutbound/deleteScMaterialOutbound',
  selectScMaterialOutboundById: '/ygsjzs/scMaterialOutbound/selectScMaterialOutboundById',
  selectScMaterialOutboundByPage: '/ygsjzs/scMaterialOutbound/selectScMaterialOutboundByPage',
  exportMaterialOutbound: '/ygsjzs/scProductionExport/exportMaterialOutbound'
}
